<template>
  <el-dialog :visible.sync="modalStopCustom" :title="$t('socialPosts.create.confirmStopCustom.title')" :show-close="false">

    <span>
      {{ $t('socialPosts.create.confirmStopCustom.text') }}
    </span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeModal">
            <span>{{
                $t('portals.list.close')
              }}</span>
         </el-button>

      <el-button type="primary" @click="setValuesFromInitial">
            <span>{{ $t('portals.list.confirm') }}</span>
         </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'PostEditoCreateModalConfirmStopCustom',
  computed: {
    ...mapState('socialPostsCreationPostEditorial',
      ['modalStopCustom', 'stopCustomNetwork'])
  },
  methods: {
    ...mapMutations('socialPostsCreationPostEditorial',
      ['setModalStopCustom']),
    closeModal () {
      this.setModalStopCustom(false)
      switch (this.stopCustomNetwork) {
        case 'facebook':
          this.$store.commit('socialPostsCreationPostEditorial/setCustomFacebook', true)
          break
        case 'instagram':
          this.$store.commit('socialPostsCreationPostEditorial/setCustomInstagram', true)
          break
        case 'google':
          this.$store.commit('socialPostsCreationPostEditorial/setCustomGoogle', true)
          break
      }
    },
    setValuesFromInitial () {
      switch (this.stopCustomNetwork) {
        case 'facebook':
          this.$store.commit('socialPostsCreationPostEditorial/setInitialValuesFacebook')
          break
        case 'instagram':
          this.$store.commit('socialPostsCreationPostEditorial/setInitialValuesInstagram')
          break
        case 'google':
          this.$store.commit('socialPostsCreationPostEditorial/setInitialValuesGoogle')
          break
      }
      this.$forceUpdate()
      this.setModalStopCustom(false)
    }
  }
}
</script>

<style scoped>

</style>
